import { jsxs as p, jsx as m } from "react/jsx-runtime";
import { withManagedProps as c } from "@made-people/managed-props";
import { z as o } from "zod";
import { withZod as l } from "@made-people/react-prop-guard";
import { logoCardStyling as f } from "./index-blueprint.es.js";
import { responsiveImageSchema as h, ResponsiveImage as d } from "@made-people/blueprint-responsive-image";
import { useLink as g } from "@made-people/grease-link";
import { badgeSchema as C, Badge as L } from "@made-people/blueprint-badge";
import "@made-people/blueprint";
const S = o.object({
  badge: C.optional(),
  logo: h.optional(),
  link: o.object({
    href: o.string().optional()
  }).optional()
}), B = o.custom().optional(), j = o.object({
  ...S.shape,
  features: o.object({}).optional(),
  variants: o.custom().optional()
}), M = c(
  "LogoCard",
  l(
    j,
    ({ variants: i, logo: t, badge: a, link: e, features: {} = {} }) => {
      var s;
      const r = f.styles(i), n = g();
      return /* @__PURE__ */ p(
        n,
        {
          href: (e == null ? void 0 : e.href) ?? "/",
          title: ((s = t == null ? void 0 : t.image) == null ? void 0 : s.alt) ?? "",
          className: r.base,
          children: [
            (a == null ? void 0 : a.label) && /* @__PURE__ */ m(L, { className: r.badge, ...a }),
            /* @__PURE__ */ m(
              d,
              {
                ...t,
                className: r.logo,
                displaySize: "200px"
              }
            )
          ]
        }
      );
    }
  )
);
export {
  M as LogoCard,
  S as LogoCardContentSchema,
  j as LogoCardSchema,
  B as LogoCardVariantsSchema
};
//# sourceMappingURL=index.es.js.map
